import React, { useEffect, useRef, useState } from 'react';
import { loadFromLocalStorage, saveToLocalStorage } from '../elements/api/CookieManagement';
import CenterBox from '../elements/centerBox';
import useInterval from '../Hooks/useInterval';
import * as api from '../elements/api/api';
import * as cf from '../elements/api/CoreFunctions';

import * as bm from '../elements/api/BookmarkManagement'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';



function AddBookmarkForm(props) {

    const [mediaType, setMediaType] = useState("audio")
    const [addClipToPlaylist, setAddClipToPlaylist] = useState(false)

    const closeWindow = () => {
        props.setShowAddClipFromBookmarkForm(false)
    }

    const addBookmark = () => {
        const mail = props.sendMailNotification ? props.mail : ""
        console.log(mail)
        cf.addJob(props.rows, mediaType, props.bookmark[bm.CLIP_URL], mail, props.setRows,closeWindow,props.openSelectLanguageForm)
        if(addClipToPlaylist)
            props.addToAdditionalActions(props.bookmark[bm.CLIP_URL],{[cf.ADDITIONAL_ACTION_ADD_TO_PLAYLIST]:addClipToPlaylist, [cf.ADDITIONAL_ACTION_ADD_TO_BOOKMARKS]: false})
    }


    return (

        <div class="overlay">
            <div class="kasten" >
                <button class="close-btn" onClick={closeWindow}>×</button>
                <h4>{props.bookmark[bm.TITLE]}</h4>
                <Form.Group className="mb-3 border p-3 rounded">
                    Please select format:<br />

                    <select onChange={(e) => setMediaType(e.target.value)} id="media" name="media">
                        <option value="audio">Audio</option>
                        <option value="video">Video</option>
                    </select><br /><br />
        <Form.Check onChange={(e) => setAddClipToPlaylist(e.target.checked)} type="checkbox"  label="Add to playlist" />

                </Form.Group>

                <Button onClick={addBookmark} variant="primary">Add clip</Button>

            </div>
        </div>
    );

}

export default AddBookmarkForm;